import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import * as Styled from "./breadcrumbs.style";
import { TabSubHeader } from "ui/components/panels/home-menu/tabs/tab-header";
import { actions, useAppDispatch } from "store";
export var FolderBreadcrumbs = function (_a) {
    var folders = _a.folders, activeFolderId = _a.activeFolderId, onDrop = _a.onDrop;
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var breadcrumbs = [];
    var folder = folders.find(function (folder) { return folder.id === activeFolderId; });
    var _loop_1 = function () {
        var parentId = folder.parentId;
        breadcrumbs.push(folder);
        folder = folders.find(function (f) { return f.id === parentId; });
    };
    while (folder) {
        _loop_1();
    }
    breadcrumbs.reverse();
    var rootFolderLabel = t("home-menu.saved-systems.sub-header");
    var onSetActiveFolderId = useCallback(function (id) { return dispatch(actions.setActiveFolderId(id)); }, [dispatch]);
    return (_jsxs(Styled.Breadcrumbs, { children: [breadcrumbs.length ? (_jsx(Styled.DropTargetLink, { onDragOver: function (e) { return e.preventDefault(); }, onDrop: function (e) {
                    e.preventDefault();
                    onDrop(null);
                }, onClick: function () { return onSetActiveFolderId(null); }, children: rootFolderLabel })) : (_jsx(TabSubHeader, { header: rootFolderLabel })), breadcrumbs.map(function (crumb, index) {
                return index === breadcrumbs.length - 1 ? (_jsx(TabSubHeader, { header: " / ".concat(crumb.name) }, crumb.id)) : (_jsxs(_Fragment, { children: [" ", "/", " ", _jsx(Styled.DropTargetLink, { onDragOver: function (e) { return e.preventDefault(); }, onDrop: function (e) {
                                e.preventDefault();
                                onDrop(crumb.id);
                            }, onClick: function () { return onSetActiveFolderId(crumb.id); }, children: _jsx(TabSubHeader, { header: crumb.name }) }, crumb.id)] }));
            })] }));
};
